import { useEffect, useReducer } from "react";

/**
 * Re-renders every `everyMs` and returns the time of this render (#484): a
 * line that reads the clock - "right now: open", "saved 9 min ago" - moves
 * as time passes instead of keeping the moment it was first drawn. The
 * time is read at render, not at the last tick, so an override set a
 * moment ago is already in force when the save's re-render lands.
 */
export function useNow(everyMs = 30_000): Date {
  const [, tick] = useReducer((n: number) => n + 1, 0);
  useEffect(() => {
    const id = window.setInterval(tick, everyMs);
    return () => window.clearInterval(id);
  }, [everyMs]);
  return new Date();
}
